/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import { prop } from 'ramda';
import React from 'react';
import { connect } from '@airglow/store-redux';
import {
  selectActiveWorkspace,
  selectGroupedWorkspaces,
  selectWorkspaceConfig
} from '../../common/selectors';
import SettingsValidationContainer from './settings.validation.container';
import {
  error,
  newEnabledViewPlugins,
  newSettingsValidation,
  saveToOrg,
  saving,
  selectedWorkspace,
  setting,
  workspaceName
} from '../data/prefabs';
import {
  createWorkspace,
  deleteWorkspace,
  saveWorkspace,
  selectWorkspace
} from '../actions';
import {
  selectSelectedWorkspace,
  selectUpdatedEnabledViewPlugins,
  selectViewPluginsGrouped,
  selectWorkspaceEditable,
  selectWorkspaceDirty
} from '../selectors';
import WorkspaceView from '../../ui/workspaces';

import { workspacesOpen } from '../../casing/data/prefabs';

const mapState = (state, props) => {
  const editable = selectWorkspaceEditable(state);
  const workspaceConfig = selectWorkspaceConfig(state);

  return ({
    activeWorkspace: prop('id', selectActiveWorkspace(state)),
    error: error.isOn(state),
    editable,
    enabledViewPlugins: selectUpdatedEnabledViewPlugins(state),
    isDirty: selectWorkspaceDirty(state),
    open: workspacesOpen.isOpen(state),
    saveToOrg: saveToOrg.isOn(state),
    saving: saving.isOn(state),
    selectedSetting: setting.value(state),
    selectedWorkspace: prop('id', selectSelectedWorkspace(state)),
    settingsValidationWidget: <SettingsValidationContainer editable={editable} {...props} />,
    showOrgWorkspaces: workspaceConfig.allowOrgWorkspaces,
    showUserWorkspaces: workspaceConfig.allowUserWorkspaces,
    viewPlugins: selectViewPluginsGrouped(state),
    workspaces: selectGroupedWorkspaces(state)
  });
};

const mapHandlers = dispatch => ({
  onChangeSaveToOrg: () => dispatch(saveToOrg.toggleAction),
  onChangeWorkspaceName: v => dispatch(workspaceName.changeAction(v)),
  onClose: () => dispatch(workspacesOpen.turnOffAction),
  onCreateWorkspace: () => dispatch(createWorkspace()),
  onDeleteWorkspace: () => dispatch(deleteWorkspace()),
  onUpdateWorkspace: () => dispatch(saveWorkspace()),
  onPressSelect: () => {
    dispatch(selectWorkspace());
    dispatch(workspacesOpen.turnOffAction);
  },
  onSelectSetting: v => dispatch(setting.changeAction(v)),
  onSelectViewPlugins: v => dispatch(newEnabledViewPlugins.changeAction(Array.from(v))),
  onSelectWorkspace: (v) => {
    dispatch(selectedWorkspace.changeAction(v));
    dispatch(newEnabledViewPlugins.resetAction);
    dispatch(newSettingsValidation.resetAction);
  }
});

export default connect(mapState, mapHandlers)(WorkspaceView);
